import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs'; 
import { formatNumber } from '@angular/common';
// Get product from Localstorage

@Injectable({
  providedIn: 'root'
})
export class PoolingPortalService {

  private fleet = new BehaviorSubject('');
  fleet$ = this.fleet.asObservable();

  updateFleetValue(value) {
    this.fleet.next(value);
  }

  private get isfleet() {
    return this.fleet.getValue()
  }

  public getVslOwnerLabel(szName:string,ownersList:any) {
    let Owner = (ownersList?.length > 0) ? ownersList.filter((item:any) => { 
        // if(item.value == szName){
        if(item.id == szName){
          return item;
        }
    }) : [];
    return (ownersList?.length > 0) ? Owner[0]?.name : '';
  }
  
  public subpool(vessels:any) {
    let subPoolAry:any = [];
     vessels.map( (ele: any) => {
      if(ele.subPool){
        if(ele.subPool && !subPoolAry.includes(ele.subPool)){
          subPoolAry.push(ele.subPool) 
        }
      }
    }); 
    return subPoolAry.sort();
  }
  public ships(vessels:any) {
    let ships:any = [];
     vessels.map( (ele: any) => {
      if(ele.vslOwner && !ships.includes(ele.vslName)){
        ships.push(ele.vslName);
      }
    });
    return ships.sort();
  }

  public getMonthNames (){
    return ["January", "February", "March", "April", "May", "June","July", "August", "September", "October", "November", "December"];
  }

  public getMonthShortNames (){
    return  ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  }
  public convertTime12to24(time12h) {
    let hours = time12h.hour;
    let minutes = time12h.minute;
    let modifier = time12h.ampm;
    if (modifier == "PM" && hours < 12) hours = hours + 12;
    if (modifier == "AM" && hours == 12) hours = hours - 12;
    if (hours < 10) hours = "0" + hours;
    if (minutes < 10) minutes = "0" + minutes;
    const times = hours + ":" + minutes;
    return times;
  };

  public convertTime24to12 = (timeString) => {
    let [hourString, minute] = (timeString) ? timeString?.split(":") : '';
    let hour = +hourString % 24;
    if(minute < 10){
      minute = minute.slice(1);
    }
    return { hour: (hour % 12 || 12), minute: parseInt(minute), ampm: (hour < 12 ? "AM" : "PM") };
  }

  public compareValues(key:any,order = 'asc') {
    return function innerSort(a:any, b:any) {
      let x = a;
      let y = b;
      if (!x.hasOwnProperty(key) || !y.hasOwnProperty(key)) {
          return 0;
      }
      const varA = (typeof x[key] === 'string')
        ? x[key].toUpperCase() : x[key];
      const varB = (typeof b[key] === 'string')
        ? y[key].toUpperCase() : y[key];

      let comparison = 0;
      if (varA > varB) {
        comparison = 1;
      } else if (varA < varB) {
        comparison = -1;
      }
      return (
        (order === 'desc') ? (comparison * -1) : comparison
      );
    };
  }

  financeNumber(input,field = '',sign = '') {
    let number = formatNumber(input,'en','1.2-2');
    

    if(Math.sign(input) == 1 && field == 'fees'){
      return '(' + sign + formatNumber(input,'en','1.2-2')  +')';
    }
    else if(Math.sign(input) == -1 && field == 'fees'){
      return  sign + formatNumber(input *-1,'en','1.2-2');
    }
    else if(Math.sign(input) == -1 && field == 'other'){
      return  '(' + formatNumber(input *-1,'en','1.2-2') +')';
    }
    else{
      return number;
    }
  }
   
  /**************************** --------------END------END-----------  ************************************/
}